export default __webpack_public_path__ + "static/media/regulatory--stop--g1.7d97baab.png";